import { useEffect } from "react";

/**
 * Suppresses Google AdSense Auto Ads on sensitive routes
 * (payment, checkout and legal pages) without removing AdSense globally.
 */
export function NoAutoAds() {
  useEffect(() => {
    const w = window as unknown as { adsbygoogle?: { pauseAdRequests?: number } };
    w.adsbygoogle = w.adsbygoogle || {};
    w.adsbygoogle.pauseAdRequests = 1;
    return () => {
      const win = window as unknown as { adsbygoogle?: { pauseAdRequests?: number } };
      if (win.adsbygoogle) win.adsbygoogle.pauseAdRequests = 0;
    };
  }, []);

  return null;
}
